module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/185-haiti-6d19afe69360c33af3e99f667cefbdc2.svg";